<template>
  <div>
    <div class="section">
      <div class="field">
        <label>Select Service</label>
        <div class="control">
          <div class="select">
            <select v-model="service" @change="checkPreviousService()">
              <option value="">Select Service</option>
              <option v-for="(service_row, index) in service_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <!--
      <div class="field">
        <label>Select Team</label>
        <div class="control">
          <div class="select">
            <select v-model="team">
              <option value="">Select Team</option>
              <option v-for="(team_row, index) in team_list" :key="index" :value="team_row.id" v-text="team_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      -->
      <div class="field" v-show="frontdesk_team === 1">
        <label>Receive from other team?</label>
        <div class="control">
          <div class="select">
            <select v-model="receive_type">
              <option v-for="(receive_type_row, index) in receive_type_list" :key="index" :value="receive_type_row.value" v-text="receive_type_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div v-show="frontdesk_team === 1" v-for="(event_row, index) in event_list" :key="index" class="field">
        <label v-text="event_row.title"></label>
        <div class="control">
          <money :class="{'input': true}" v-model="event_list[index].receive_tickets" v-bind="number_format"></money>
        </div>
        <label v-show="event_row.complimentary === 1" v-text="event_row.title + ' (Complimentary)'"></label>
        <div class="control" v-show="event_row.complimentary === 1">
          <money :class="{'input': true}" v-model="event_list[index].receive_complimentary_tickets" v-bind="number_format"></money>
        </div>
      </div>
      <div class="field" v-show="frontdesk_team === 2">
        <label>Number of Row Seats</label>
        <div class="control">
          <input type="number" class="input" v-model.number="row_seats">
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="button" class="button is-link" @click="getModalConfirmation('Service Task', 'Are you sure the datas are correct?', 'submit')">Submit</button>
        </div>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="submitData"></confirmation-modal>
  </div>
</template>

<script>
import {Money} from 'v-money'
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'

export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      service_list: [],
      service: '',
      team_list: [],
      team: '',
      frontdesk_team: 0,
      receive_type_list: [
        {
          title: 'Yes',
          value: 1
        },
        {
          title: 'No',
          value: 0
        }
      ],
      receive_type: 1,
      event_list: [],
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      row_seats: 1
    }
  },
  components: {
    Money
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getService()
    this.getTeam()
    this.checkFrontdeskTeam()
    this.checkCurrentTask()
  },
  methods: {
    // Untuk cek apakah TL, CC atau HD sudah bikin task untuk hari ini atau belum
    checkCurrentTask () {
      var self = this
      self.flyGetSession('task/check_current_task').then(function (response) {
        if (response.data.response_code === 1) {
          if (response.data.data === 'fd') {
            self.$router.push('/panel/task_service')
          } else if (response.data.data === 'fa') {
            self.$router.push('/panel/task/attendance')
          } else {
            self.$router.push('/panel/profile')
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // Untuk cek apakah sebelumnya ada service yang oper tiket atau tidak
    checkPreviousService () {
      if (this.frontdesk_team === 1) {
        var self = this
        self.flyPostSession('task/check_previous_service', {
          service: this.service
        })
        .then(function (response) {
          if (response.data.response_code === 1) {
            if (response.data.data.exists === 1) {
              self.event_list = response.data.data.event_list
            }
          } else {
            var result = response.data.message
            self.errors.clear()
            for (var name in response.data.message) {
              self.errors.add(name, result[name])
            }
          }
        })
        .catch(function (response) {
          self.errorMessage(response)
        })
      }
    },
    // Untuk cek apakah TL ini adalah team Frontdesk atau bukan
    checkFrontdeskTeam () {
      var self = this
      self.flyGetSession('task/check_frontdesk_team').then(function (response) {
        if (response.data.response_code === 1) {
          self.frontdesk_team = response.data.data.frontdesk_team
          self.event_list = response.data.data.event_list
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    // Untuk ambil list service
    getService () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('task/get_service')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.service_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // Untuk ambil list team TL ini bertugas
    getTeam () {
      var self = this
      self.flyGetSession('task/get_team')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.team_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData (confirmData) {
      if (confirmData.flag === true) {
        if (confirmData.label === 'submit') {
          var self = this
          self.flyPostSession('task/submit_task', {
            service: this.service,
            team: this.team,
            receive_type: this.receive_type,
            event_list: this.event_list,
            row_seats: this.row_seats
          }).then(function (response) {
            if (response.data.response_code === 1) {
              // Success
              self.service = ''
              self.team = ''
              self.receive_type = 1
              // self.checkFrontdeskTeam()
              self.$geb.emit({id: 'alert_modal', title: 'Thank You!', content: 'Data yang anda input sukses!', button_text: 'OK'})
              if (response.data.data === 'fd') {
                self.$router.push('/panel/task_service')
              } else if (response.data.data === 'fa') {
                self.$router.push('/panel/task/attendance')
              } else {
                self.$router.push('/panel/profile')
              }
            } else {
              var result = response.data.message
              self.errors.clear()
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
            }
          }).catch(function (response) {
            self.errorMessage(response)
          })
        }
      }
      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/Home.vue